export const selectCurrentUser = (state: any) => state.user.currentUser;

export const selectIsAuthLoading = (state: any) => state.user.isLoading;
